import React from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog.js";

type AppCaseQrIslandProps = {
  appUrl?: unknown;
  title?: unknown;
};

type QrEncoder = {
  toDataURL: (text: string, options: {
    width: number;
    margin: number;
    errorCorrectionLevel: "M";
  }) => Promise<string>;
};

export async function generateAppCaseQrDataUrl(
  appUrl: string,
  loadEncoder: () => Promise<QrEncoder> = () => import("qrcode")
): Promise<string> {
  const encoder = await loadEncoder();
  return encoder.toDataURL(appUrl, { width: 320, margin: 2, errorCorrectionLevel: "M" });
}

export function AppCaseQrIsland(props: AppCaseQrIslandProps) {
  const appUrl = typeof props.appUrl === "string" ? props.appUrl : "";
  const title = typeof props.title === "string" ? props.title : "应用";
  const [open, setOpen] = React.useState(false);
  const [qrDataUrl, setQrDataUrl] = React.useState<string | null>(null);
  const [error, setError] = React.useState(false);

  async function showQrCode() {
    setOpen(true);
    if (qrDataUrl || !appUrl) return;
    setError(false);
    try {
      setQrDataUrl(await generateAppCaseQrDataUrl(appUrl));
    } catch {
      setError(true);
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" onClick={() => void showQrCode()} className="inline-flex size-8 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100 hover:text-slate-900" aria-label="查看二维码">
          <QrIcon />
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-sm rounded-2xl border-slate-200 bg-white p-6">
        <DialogHeader className="pr-8">
          <DialogTitle className="text-base text-slate-950">微信扫码打开应用</DialogTitle>
          <DialogDescription className="truncate text-slate-500">{title}</DialogDescription>
        </DialogHeader>
        <div className="flex aspect-square items-center justify-center rounded-xl bg-slate-50 p-4">
          {qrDataUrl ? <img src={qrDataUrl} alt={`${title} 访问二维码`} className="h-full w-full" /> : error ? <p role="alert" className="text-center text-sm text-red-600">二维码生成失败，请稍后重试。</p> : <p className="text-sm text-slate-500">正在生成二维码…</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}

function QrIcon() {
  return <svg aria-hidden="true" className="size-4" viewBox="0 0 24 24" fill="none"><path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v6h-6v-2" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" /></svg>;
}
